import { EOtevrenyUzavreny } from 'enums/isin/udaje/otevrenyUzavreny';

const otevrenyUzavrenySelect = [
    {
        value: EOtevrenyUzavreny.OTEVRENY,
        labelcz: 'ISIN_EMISE_LIST_TYP_O'
    },
    {
        value: EOtevrenyUzavreny.UZAVRENY,
        labelcz: 'ISIN_EMISE_LIST_TYP_U'
    }
];

export default otevrenyUzavrenySelect;
